import { render, staticRenderFns } from "./AdministrativePayroll.vue?vue&type=template&id=364b09a6"
import script from "./AdministrativePayroll.vue?vue&type=script&lang=js"
export * from "./AdministrativePayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports